import { all, call, put, fork, takeEvery } from 'redux-saga/effects';
import moment from 'moment';
import {
  PATIENTS_BYUSER_GET_LIST,
  PATIENTS_BYDOCTOR_GET_LIST,
  PATIENT_GET_INFO,
  PATIENT_ADD_ITEM,
  PATIENT_EDIT_ITEM,
  PATIENT_REMOVE_ITEM,
  PATIENTS_CLEAR_DATA,
  PATIENT_CLEAR_DATA,
  PATIENT_CLEAR_MESSAGES,
} from '../actions';

import {
  getPatientsByUserListSuccess,
  getPatientsByUserListError,
  getPatientsByDoctorListSuccess,
  getPatientsByDoctorListError,
  getPatientInfoSuccess,
  getPatientInfoError,
  addPatientItemSuccess,
  addPatientItemError,
  editPatientItemSuccess,
  editPatientItemError,
  removePatientItemSuccess,
  removePatientItemError,
} from './actions';

import queryString from 'query-string'; // import the queryString class

//1. Our worker saga

//* GET LIST OF THE PATIENTS PER USER //--------------------------------------------------------
const getPatientsByUserListRequest = async (payload) => {
  //console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/patients?archived=0`, {
    method: 'get',
    credentials: 'include',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data.data;
    })
    .catch((error) => console.error(error));
};

function* getPatientsByUserList(payload) {
  // payload will be the username from the component
  //console.log(payload);
  try {
    const response = yield call(getPatientsByUserListRequest, payload);
    yield put(getPatientsByUserListSuccess(response));
  } catch (error) {
    yield put(getPatientsByUserListError(error));
  }
}

//* GET LIST OF THE PATIENTS PER DOCTOR //--------------------------------------------------------
const getPatientsByDoctorListRequest = async (payload) => {
  //console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/patients?archived=0`, {
    method: 'get',
    credentials: 'include',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      return data.data;
    })
    .catch((error) => console.error(error));
};

function* getPatientsByDoctorList(payload) {
  // payload will be the username from the component
  //console.log(payload);
  try {
    const response = yield call(getPatientsByDoctorListRequest, payload);
    yield put(getPatientsByDoctorListSuccess(response));
  } catch (error) {
    yield put(getPatientsByDoctorListError(error));
  }
}

//* GET INFO OF THE PATIENT  //----------------------------------------------------------
const getPatientInfoRequest = async (payload) => {
  //console.log(payload);
  //console.log(payload.payload);
  let patientId = payload.payload;

  return await fetch(`/mick/patients/${patientId}/info`, {
    method: 'get',
    credentials: 'include',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      //console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getPatientInfo(payload) {
  // payload will be the username from the component
  //console.log(payload);
  try {
    const response = yield call(getPatientInfoRequest, payload);
    yield put(getPatientInfoSuccess(response[0]));
  } catch (error) {
    yield put(getPatientInfoError(error));
  }
}

//* ADD PATIENT // ----------------------------------------------------------------------------------------------
const addPatientItemRequest = async (payload) => {
  // console.log("inside addPatientItemRequest");

  var diseases = payload.diseases.map((item) => item.value);
  var allergies = payload.allergies.map((item) => item.value);

  //https://stackoverflow.com/questions/38251763/moment-js-to-convert-date-string-into-date
  const birthdateMoment = moment(payload.birthdate, 'DD/MM/YYYY');
  //var birthdate = birthdateMoment._i;
  const birthdate = birthdateMoment.format('YYYY/MM/DD').toString();

  var {
    username,
    firstName,
    lastName,
    alias,
    gender,
    ethnicity,
    otherDiseases,
    otherAllergies,
    city,
    postalCode,
    address,
    country,
    phone,
    email,
    patientComments,
    company,
    fiscalId,
    fiscalCity,
    fiscalAddress,
    fiscalPostalCode,
    fiscalCountry,
    fiscalPhone,
    fiscalEmail,
    GDPRconsent,
  } = payload;

  console.log(diseases, allergies);

  if (diseases == null) {
    diseases = [];
  }

  if (allergies == null) {
    allergies = [];
  }

  if (Array.isArray(otherDiseases) && otherDiseases.length) {
    //console.log("Concat otherAllergies with allergies");
    diseases = diseases.concat(otherDiseases);
  }

  if (Array.isArray(otherAllergies) && otherAllergies.length) {
    //console.log("Concat otherAllergies with allergies");
    allergies = allergies.concat(otherAllergies);
  }

  if (postalCode) {
    address = address + ', ' + postalCode;
  }

  if (fiscalPostalCode) {
    fiscalAddress = fiscalAddress + ', ' + fiscalPostalCode;
  }

  var data = {
    username, //string - doctor email
    name: firstName, //string
    surname: lastName, //string
    alias, //string
    birthday: birthdate, //string, yyyy/mm/dd,
    gender, //string
    ethnicity, //string
    diseases, //array
    allergies, //array
    city, //string
    address, //string
    country, //string
    phone, //  numeric
    email, //  string
    patientComments, //  string
    company, //  string
    fiscalId, //  string
    fiscalCity, //  string
    fiscalAddress, //  string
    fiscalCountry, //  string
    fiscalPhone, //  numeric
    fiscalEmail, //  string
    consent: GDPRconsent, // boolean
  };

  //* old method
  // Nel caso in cui non avessi array nel payload:
  // var formBody = [];
  //   for (var property in data) {
  //     var encodedKey = encodeURIComponent(property);
  //     var encodedValue = encodeURIComponent(data[property]);
  //     formBody.push(encodedKey + "=" + encodedValue);
  //   }
  //   formBody = formBody.join("&");

  // //https://github.com/github/fetch/issues/256
  // // usando uno script JS manuale
  // function getQueryString(params) {
  //   return Object.keys(params)
  //     .map(k => {
  //       // if find an array
  //       if (Array.isArray(params[k])) {
  //         return params[k]
  //           .map(val => `${encodeURIComponent(k)}[]=${encodeURIComponent(val)}`)
  //           .join("&");
  //       }

  //       // for the rest that are strings or numbers
  //       return `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`;
  //     })
  //     .join("&");
  // }

  // var stringedData = getQueryString(data);

  //console.log(stringedData);
  /* OUTPUT username=fvigilante%40sequentiabiotech.com&name=Fulvio&surname=Vigilante&birthday=10%2F10%2F1970&gender=Male&ethnicity=Arabs&diseases[]=Amputation&diseases[]=Attention%20deficit%20hyperactivity%20disorder%20(ADHD)&allergies[]=Hot%20peppers&allergies[]=Fruit&allergies[]=Other%20all&city=Prato&address=via%20del%20Purgatorio%2016&country=Italia&phone=664862507&email=anthares83%40gmail.com&company=BMC&fiscalId=6669847156194asdasdw&fiscalCity=Prato&fiscalAddress=via%20del%20Purgatorio%2016&fiscalCountry=Italia&fiscalPhone=664862507&fiscalEmail=anthares83%40gmail.com*/

  //* utilizzando il modulo queryString
  var stringedData = queryString.stringify(data, {
    arrayFormat: 'bracket',
    skipNull: true,
  });

  console.log(data);
  console.log(stringedData);

  return await fetch(`/mick/patients/add/`, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      Accept: 'application/x-www-form-urlencoded',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: stringedData,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* addPatientItem(payload) {
  //console.log(payload);
  var item = payload.payload;
  try {
    const response = yield call(addPatientItemRequest, item);

    if (!response.includes('ERROR')) {
      yield put(addPatientItemSuccess(response));
    } else {
      yield put(addPatientItemError(response, item));
    }
  } catch (error) {
    yield put(addPatientItemError(error));
  }
}

//* EDIT PATIENT INFO  // -----------------------------------------------------------
const editPatientItemRequest = async (payload) => {
  console.log('editPatientItemRequest -> payload', payload);

  var {
    //* GENERAL
    patientId, //string (for identification)
    firstName, //string
    lastName, //string
    alias, //string
    patientComments, //string
    doctorId, //string

    //* METADATA
    gender, //string
    ethnicity, //string
    otherDiseases, //list-array
    otherAllergies, //list-array

    //* CONTACT
    city, //string
    postalCode, //string
    address, //string
    country, //string
    phone, //numeric
    email, //string

    //* FISCAL
    company, //string
    fiscalId, //string
    fiscalCity, //string
    fiscalAddress, //string
    fiscalPostalCode, //string
    fiscalCountry, //string
    fiscalPhone, //numeric
    fiscalEmail, //string

    //* GDPR
    GDPRconsent, //boolean
  } = payload;

  var diseases = payload.diseases.map((item) => item.value); //list-array
  var allergies = payload.allergies.map((item) => item.value); //list-array
  //if there are other values not included in the default list, add them in the array
  if (Array.isArray(otherDiseases) && otherDiseases.length) {
    diseases = diseases.concat(otherDiseases);
  }
  if (Array.isArray(otherAllergies) && otherAllergies.length) {
    allergies = allergies.concat(otherAllergies);
  }
  if (postalCode) {
    address = address + ', ' + postalCode;
  }

  if (fiscalPostalCode) {
    fiscalAddress = fiscalAddress + ', ' + fiscalPostalCode;
  }

  const birthdateMoment = moment(payload.birthdate, 'DD/MM/YYYY');
  const birthdate = birthdateMoment.format('YYYY/MM/DD').toString();

  //? I'm using this function and not the npm module stringify as done for add-forms (in edit form the body is sent in a different way)
  function getQueryStringObjectType(params) {
    return Object.keys(params)
      .map((k) => {
        // if found an array
        if (Array.isArray(params[k])) {
          return `"${encodeURIComponent(k)}":[${params[k]
            .map((val) => `"${encodeURIComponent(val)}"`)
            .join(',')}]`;
        }

        // if found a number or a boolean doesn't add brackets
        if (typeof params[k] == 'number' || typeof params[k] == 'boolean') {
          return `"${encodeURIComponent(k)}":${encodeURIComponent(params[k])}`;
        }
        // for common strings
        return `"${encodeURIComponent(k)}":"${encodeURIComponent(params[k])}"`;
      })
      .join(',');
  }

  var formBodyGeneralData = {
    name: firstName, //string
    surname: lastName, //string
    alias: alias, //string
    birthday: birthdate, //string, yyyy/mm/dd,
    doctorId: doctorId, //string
  };

  formBodyGeneralData = getQueryStringObjectType(formBodyGeneralData);

  var formBodyMetaData = {
    'metadata.gender': gender, //string
    'metadata.ethnicity': ethnicity, //string
    'metadata.comments': patientComments, //  string
    'metadata.diseases': diseases, //list-array
    'metadata.allergies': allergies, //list-array
  };

  formBodyMetaData = getQueryStringObjectType(formBodyMetaData);

  var formBodyContactData = {
    'contact.city': city, //string
    'contact.address': address, //string
    'contact.country': country, //string
    'contact.phone': phone, //  numeric
    'contact.email': email, // string
  };

  formBodyContactData = getQueryStringObjectType(formBodyContactData);

  var formBodyFiscalData = {
    'fiscal-information.company': company, //string
    'fiscal-information.fiscalId': fiscalId, //string
    'fiscal-information.fiscalCity': fiscalCity, //string
    'fiscal-information.fiscalAddress': fiscalAddress, //string
    'fiscal-information.fiscalCountry': fiscalCountry, //string
    'fiscal-information.fiscalPhone': fiscalPhone, //  numeric
    'fiscal-information.fiscalEmail': fiscalEmail, // string
  };

  formBodyFiscalData = getQueryStringObjectType(formBodyFiscalData);

  var formBodyGDPRData = {
    'GDPR.consent': GDPRconsent, //boolean
  };

  formBodyGDPRData = getQueryStringObjectType(formBodyGDPRData);

  //var body = `patientId=${patientId}&toBeModified={${formBodyGeneralData},${formBodyMetaData},${formBodyContactData},${formBodyFiscalData}}`;

  var body = `patientId=${patientId}&toBeModified={${formBodyGeneralData},${formBodyMetaData},${formBodyContactData},${formBodyFiscalData},${formBodyGDPRData}}`;

  console.log('body', body);

  return await fetch(`/mick/patients/modify/`, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: body,
  })
    .then((response) => {
      //console.log(response);
      return response.text();
    })
    .then((response) => {
      //console.log(response);
      return response;
    });
};

function* editPatientItem(payload) {
  try {
    const response = yield call(editPatientItemRequest, payload.payload);

    if (!response.includes('ERROR')) {
      yield put(editPatientItemSuccess(response));
    } else {
      yield put(editPatientItemError(response));
    }
  } catch (error) {
    console.log(error);
    yield put(editPatientItemError(error));
  }
}

//* REMOVE PATIENT //--------------------------------------------------------
const removePatientItemRequest = async (payload) => {
  console.log(payload.payload);
  let patientId = payload.payload;

  return await fetch(`/mick/patients/${patientId}/remove`, {
    method: 'delete',
    credentials: 'include',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
    },
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* removePatientItem(payload) {
  try {
    const response = yield call(removePatientItemRequest, payload);
    if (!response.includes('ERROR')) {
      yield put(removePatientItemSuccess(response));
    } else {
      yield put(removePatientItemError(response));
    }
  } catch (error) {
    yield put(removePatientItemError(error));
  }
}

//* CLEAR PATIENTS DATA // -------------------------------------------------------------------

function clearPatientsData({ payload }) {
  const { history } = payload;
}

//* CLEAR PATIENT DATA // -------------------------------------------------------------------

function clearPatientData({ payload }) {
  const { history } = payload;
}

//* CLEAR PATIENT MESSAGES // -------------------------------------------------------------------

function clearPatientMessages({ payload }) {
  const { history } = payload;
}

//!2. Our watcher saga
// our watcher saga spawn a new task on each action

export function* watchGetListPatientsByUser() {
  yield takeEvery(PATIENTS_BYUSER_GET_LIST, getPatientsByUserList);
}

export function* watchGetListPatientsByDoctor() {
  yield takeEvery(PATIENTS_BYDOCTOR_GET_LIST, getPatientsByDoctorList);
}

export function* watchGetInfoPatient() {
  yield takeEvery(PATIENT_GET_INFO, getPatientInfo);
}

export function* watchAddPatient() {
  yield takeEvery(PATIENT_ADD_ITEM, addPatientItem);
}

export function* watchEditPatient() {
  yield takeEvery(PATIENT_EDIT_ITEM, editPatientItem);
}

export function* watchRemovePatient() {
  yield takeEvery(PATIENT_REMOVE_ITEM, removePatientItem);
}

export function* watchClearPatients() {
  yield takeEvery(PATIENTS_CLEAR_DATA, clearPatientsData);
}

export function* watchClearPatient() {
  yield takeEvery(PATIENT_CLEAR_DATA, clearPatientData);
}

export function* watchClearPatientMessages() {
  yield takeEvery(PATIENT_CLEAR_MESSAGES, clearPatientMessages);
}

//!3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([
    fork(watchGetListPatientsByUser),
    fork(watchGetListPatientsByDoctor),
    fork(watchGetInfoPatient),
    fork(watchAddPatient),
    fork(watchEditPatient),
    fork(watchRemovePatient),
    fork(watchClearPatients),
    fork(watchClearPatient),
    fork(watchClearPatientMessages),
  ]);
}
